export function asRequired<T, U>(
  value: T | null | undefined,
  parent: U,
  property: string,
): T {
  if (typeof asOptional(value) !== 'undefined') {
    return value as T;
  }
  throw new Error(
    `Property is required in ${JSON.stringify(parent)}, property: ${property}`,
  );
}

export function asOptional<T>(value: T | null | undefined): T | undefined {
  return value == null ? undefined : value;
}

export function isDefined<T>(value?: T | null): value is T {
  return asOptional(value) !== undefined;
}

export function isNullOrUndefined<T>(value: T | null | undefined): Boolean {
  return value === null || value === undefined;
}

export function notEmpty<TValue>(value: TValue | null): value is TValue {
  return value !== null;
}

export function isObject(givenValue: any): givenValue is object {
  return (
    typeof givenValue === 'object' &&
    !Array.isArray(givenValue) &&
    givenValue !== null
  );
}
